import api from "../services/api";

export const fetchLocationSuggestions = async (query) => {
    try {
        const response = await api.get('/api/location/autocomplete', {
            params: { input: query }
        });

        const { success, data, message } = response.data;

        if (!success || !data?.predictions) {
            throw new Error(message || 'No suggestions found');
        }

        return data.predictions.map((item) => ({
            placeId: item.place_id,
            description: item.description,
        }));

    } catch (error) {
        console.error('[Location Suggestion Error]', error);
        throw new Error(error.response?.data?.message || 'Failed to fetch location suggestions');
    }
};
